import { createMatchSelector } from "connected-react-router";
import { STAFF_PATH, STAFF_MEMBER_ROUTE } from "../actions/types";

export const createStaffPath = (id, path) => `${STAFF_PATH}/${id}/${path}`;

// Search overwrites pagination.results. Prefer the last full directory.
export const getStaffDirectory = (staffState) => {
	if (Array.isArray(staffState?.directory) && staffState.directory.length > 0) {
		return staffState.directory;
	}
	return staffState?.pagination?.results || [];
};

// TODO
// This is only a temporary solution
export const getStaffById = (state) => {
	const match = createMatchSelector(STAFF_MEMBER_ROUTE)(state);

	if (match && match.params && match.params.staffId) {
		const lists = [state.staff.directory, state.staff.pagination?.results];
		for (let listIndex = 0; listIndex < lists.length; listIndex++) {
			const list = lists[listIndex];
			if (!Array.isArray(list)) {
				continue;
			}
			for (let i = 0; i < list.length; i++) {
				const model = list[i];
				if (model && model.id === match.params.staffId) {
					return model;
				}
			}
		}
	}

	return null;
};
